import { useTranslation } from "react-i18next";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface ResetFramesAlertDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
	pending?: boolean;
	scope: "source" | "meter";
	target: string;
}

export function ResetFramesAlertDialog({
	open,
	onOpenChange,
	onConfirm,
	pending,
	scope,
	target,
}: ResetFramesAlertDialogProps) {
	const { t } = useTranslation();
	const titleKey =
		scope === "source"
			? "mediaTransmitters.resetSourceTitle"
			: "mediaTransmitters.resetMeterTitle";
	const descKey =
		scope === "source"
			? "mediaTransmitters.resetSourceDescription"
			: "mediaTransmitters.resetMeterDescription";
	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{t(titleKey)}</AlertDialogTitle>
					<AlertDialogDescription>
						{t(descKey, { target })}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>{t("mediaTransmitters.cancel")}</AlertDialogCancel>
					<AlertDialogAction onClick={onConfirm} disabled={pending}>
						{t("mediaTransmitters.confirmReset")}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
